import { hamburgerMenu } from "./mobile-nav";
import {swiperInit} from "./swiper";
hamburgerMenu();
swiperInit();
